<template>
  <div class="content-list">
    <div class="input-group">
      <div class="input-group-append">
        <span id="basic-addon1" class="input-group-text">Filter by Tags</span>
      </div>
      <select ref="tagSelect" class="tag-select form-control" multiple></select>
    </div>
    <div class="input-group">
      <select ref="select" class="item-select form-control"></select>
      <div class="input-group-append">
        <button :disabled="!pool.length" class="btn btn-default" type="button" @click="add"><i class="fa fa-plus"></i>
          Add
        </button>
      </div>
    </div>

    <ul class="list-group">
      <template v-for="(item, index) in items" v-cloak :key="item.id">
        <li class="list-group-item item-data">
          <div class="btn-group-vertical shift" role="group">
            <button v-if="index" class="btn btn-default btn-xs" type="button" @click="shift(item, index, -1)"><i
                class="fa fa-arrow-up"></i></button>
            <button class="btn btn-primary btn-xs page-id" disabled type="button">{{ generateID(item) }}</button>
            <button v-if="index < items.length - 1" class="btn btn-default btn-xs" type="button"
                    @click="shift(item, index, 1)"><i class="fa fa-arrow-down"></i></button>
          </div>
          <div class="info">
            <h4 class="list-group-item-heading">{{ item.identifier }} <span v-if="item.layout" class="badge badge-info">{{
                item.layout
              }}</span></h4>
            <p v-if="item.description" class="list-group-item-text">{{ item.description }}</p>
          </div>

          <div class="btn-group actions">
            <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" type="button">
              <i class="fa fa-cog"></i>
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <a class="dropdown-item" href="#" @click="edit(item)">Edit</a>
              <a v-if="canFlow" class="dropdown-item" href="#" @click="item.showFlow = !item.showFlow">Page Flow</a>
              <div class="dropdown-divider" role="separator"></div>
              <a class="dropdown-item" href="#" @click="remove(item, index)">Remove</a>
            </div>
          </div>

          <input :name="'items[' + index + '][id]'" :value="item.id" type="hidden">
        </li>
        <li v-if="canFlow" v-show="item.showFlow" :key="'item-' + item.id" class="list-group-item flow-hooks">
          <div class="help-block small">Specify custom page flow here, if <strong>Default</strong> is specified the
            default will be linear order (the page listed below).
          </div>
          <table class="table table-condensed">
            <thead>
            <tr>
              <th>Page Flow Key</th>
              <th>Destination</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(hook, key) in item.flow.hooks" :key="'hook-' + key">
              <td>{{ key }}</td>
              <td>
                <select v-model="item.flow.hooks[key]" :name="'items[' + index + '][hooks][' + key + ']'"
                        class="form-control">
                  <option value="0">Default</option>
                  <option v-for="(page, pindex) in filteredHooks(item)" :key="'page-' + pindex" :value="page.id">
                    {{ generateID(page) }}
                  </option>
                </select>
              </td>
            </tr>
            </tbody>
          </table>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import Choices from 'choices.js'

let choices = null
let tagSelect = null
let placeholder = {
  id: 0,
  identifier: 'Select an item to add...',
  disabled: true,
  selected: true,
  placeholder: true
}

let STARTING_HASH;

export default {
  props: ['content', 'assigned', 'tags', 'url', 'type'],
  data() {
    return {
      items: [],
      filters: []
    }
  },
  computed: {
    pool() {
      let filtered = this.content
      if (this.filters.length) {
        filtered = _.filter(filtered, (item) => {
          // console.log(this.filters, item.tags, _.map(item.tags, 'name'))
          return !_.difference(this.filters, _.map(item.tags, 'name')).length
        })
      }

      // console.log(filtered)
      let data = _.differenceBy(filtered, this.items, 'id')

      if (data.length)
        data.unshift(placeholder)

      return data
    },
    prefix() {
      return this.type.substr(0, 1).toUpperCase()
    },
    canFlow() {
      return this.type === 'page'
    }
  },
  watch: {
    items(value) {
      this.updateChoices()
    },
    filters(value) {
      this.updateChoices()
    }
  },
  methods: {
    shift(item, index, dir) {
      // remove
      this.items.splice(index, 1)

      // add back
      this.items.splice(index + dir, 0, item)

      // set new index
      item.sort_index = this.items.indexOf(item)
    },
    add() {
      let selectedID = choices.getValue(true)
      let item = _.find(this.content, {id: parseInt(selectedID)})

      if (!item) {
        console.warn('Item not found.')
        return
      }

      item = _.cloneDeep(item)

      if (this.canFlow)
        this.setFlowHooks(item)

      console.log(item)

      this.items = _.union(this.items, [item])
    },
    remove(item, index) {
      this.items.splice(index, 1)
    },
    edit(item) {
      var dirty = (STARTING_HASH !== getHash(this.items))
      if (!dirty || confirm('Are you sure? Any unsaved changes will be lost.')) {
        window.location = this.editLink(item.id)
      }
    },
    editLink(id) {
      return this.url + '/' + id + '/edit'
    },
    setFlowHooks(item) {

      let hooks = {}

      if (!hooks.custom)
        hooks.custom = 0

      if (
          item.layout === 'Question' ||
          item.layout === 'IdealTextQuestion' ||
          item.layout === 'OpenResponseQuestionWithFeedback' ||
          item.layout === 'RandomEvent' ||
          item.layout === 'DragSort' ||
          item.layout === 'Menu'
      ) {
        // check for response hooks
        let responses = _.get(item, 'content.question.responses', [])

        if (item.layout === 'RandomEvent') {
          responses = _.get(item, 'content.events', [])
        }

        if (item.layout === 'DragSort') {
          responses = _.get(item, 'content.items', [])
        }

        _.each(responses, (response) => {
          if (response.flow) {
            hooks[response.flow] = 0
          }
        })
      }

      // merge available with stored hooks
      let stored = _.get(item, 'flow.hooks', {})
      if (stored === null || Array.isArray(stored))
        stored = {}

      _.each(hooks, (value, key) => {
        if (_.has(stored, key)) {
          hooks[key] = stored[key]
        }
      })

      // console.log(item.flow, hooks)
      item.showFlow = false
      _.set(item, 'flow.hooks', hooks)
    },
    filteredHooks(item) {
      return _.without(this.items, item)
    },
    generateID(item) {
      let index = this.items.indexOf(item)
      return this.prefix + '-' + (index + 1)
    },
    updateChoices() {
      let data = this.pool.concat()

      if (data.length) {
        choices.enable()
      } else {
        choices.disable()
      }

      data.forEach((item) => {
        item.value = item.id.toString()
        item.label = item.identifier
      })

      choices.setChoices(data, 'value', 'label', true)
    }
  },
  mounted() {
    // setup item select
    choices = new Choices(this.$refs.select)
    let items = this.assigned.slice()

    if (this.canFlow) {
      // set flow param
      _.each(items, (item) => {
        this.setFlowHooks(item)
      })
    }

    this.items = items

    tagSelect = new Choices(this.$refs.tagSelect, {
      choices: _.map(this.tags, (tag) => {
        return {value: tag, label: tag}
      }),
      removeItemButton: true,
      duplicateItems: false
    })

    tagSelect.passedElement.addEventListener('change', (e) => {
      this.filters = tagSelect.getValue(true)
    })

    STARTING_HASH = JSON.stringify(this.items).hashCode()
  }
}
</script>

<style lang="scss">
.input-group {
  margin-bottom: 15px;
}

.item-data {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 10px;

  .info {
    flex-grow: 1;
    margin-left: 10px;
    margin-right: 10px;
  }
}

.flow-hooks {
  background: #f5f8fa;
  padding: 10px;
}

.page-id {
  cursor: auto !important;
}
</style>
